import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "group", "clearBtn"]

  filter() {
    const query = this.inputTarget.value.toLowerCase().trim()

    if (this.hasClearBtnTarget) {
      this.clearBtnTarget.classList.toggle("hidden", !query)
    }

    this.groupTargets.forEach(group => {
      const title = (group.dataset.searchTitle || "").toLowerCase()
      const centers = (group.dataset.searchCenters || "").toLowerCase()
      const match = !query || title.includes(query) || centers.includes(query)
      group.classList.toggle("hidden", !match)
    })
  }

  clear() {
    this.inputTarget.value = ""
    this.filter()
    this.inputTarget.focus()
  }
}
